export function useGtagMock() {
  const noop = () => {
  };
  return {
    gtag: noop,
    initialize: noop,
    disableAnalytics: noop,
    enableAnalytics: noop
  };
}
